import Row from './Row.js'
import Form from './Form.js'
import Fragment from './Fragment.js'
import RowHeading from './RowHeading.js'
import TrancheFragment from './TrancheFragment.js'

import './styles.scss'

export default {
    fragment: Fragment,
    row: Row,
    form: Form,
    rowHeading: RowHeading,
    tranche: {
        fragment: TrancheFragment,
    },
}
